import * as zod from 'zod';

import { ArmPosition } from '@sb/routine-runner/types';

export default zod.object({
  latestResult: zod.array(ArmPosition).nullable(),
  resultCount: zod.number(),
});
